import styled from "styled-components"
import arrowDown from '../../../assets/arrow-down.svg'
import arrowUp from '../../../assets/arrow-up.svg'

export const Container = styled.div`
  background: #F5F5F5;
  padding: 80px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`

export const Title = styled.h5`
  color: #00A687;
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: 700;
  line-height: 36.77px;
  margin-bottom: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`

export const FaqTitle = styled.div`
  border-bottom: 1px solid #007D55;
  color: #4CC5B6;
  cursor: pointer;
  display: flex;
  font-family: Source Sans 3;
  font-size: 16px;
  font-weight: 700;
  justify-content: space-between;
  line-height: 24px;
  margin-bottom: 12px;
  padding: 12px 0;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  &:after {
    content: url(${arrowDown});
    display: block;
  }

  &.expanded:after {
    content: url(${arrowUp});
  }
`

export const FaqDescription = styled.div`
  color: #1D1D1D;
  height: 0;
  margin-bottom: 24px;
  opacity: 0;

  &.open {
    height: auto;
    opacity: 1;
  }
`